import apiClient from '@/plugins/apiClient'
let basePath = "cms/users";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: null,
          message: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
     },
     mutations:{
        error(state, err) {
            console.log('mutation error',err);
            state.message = err.response.data.message
            state.errors = err.response.data.errors
        },
        setList(state, resp) {
            console.log('mutation setList',resp);
            state.list = resp.data
            console.log('mutation setSingle',resp.data[0]);
            state.single = resp.data[0]
        },
        setMeta(state, resp){
          console.log('mutation setMeta',resp.meta);
          state.meta = resp.meta
        },
        setSingle(state, resp){
          console.log('mutation setSingle',resp.data);
          state.single = resp.data
        },
        setSingleContracts(state, resp){
          console.log('mutation setSingleContracts',resp.data);
          state.single.contracts = resp.data
        },
        setSingleStores(state, resp){
          console.log('mutation setSingleStores',resp.data);
          state.single.stores = resp.data
        }
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET LIST STORES:'+data)
                    var params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'/search?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createUser({commit}, user){
               return new Promise((resolve, reject) => {
                    console.log('Create Single User:'+user)
                    apiClient.post(basePath+'/create', user).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, user_uid){
               return new Promise((resolve, reject) => {
                    console.log('GET Single STORE:'+user_uid)
                    apiClient.get(basePath+'/'+user_uid).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET Single STORE:'+state.single.uid)
                    apiClient.patch(basePath+'/'+state.single.id+'/update',data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET Single User:'+state.single.uid)
                    apiClient.delete(basePath+'/'+state.single.id+'/delete',data).then(resp => {
                         //commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          removeErrors({state}){
               state.errors = null;
               state.message = null;
          },
          setMeta({commit}, data){
               console.log('action meta',data);
               commit('setMeta',{meta:data});
               // commit('success', true);
          }
     },
}